import { t as getTheme_v2 } from "./getTheme_v2-y09KqtEb.js";
/**
* @internal
*/
const EMPTY_ARRAY = [], EMPTY_RECORD = {}, POPOVER_MOTION_DURATION = .2, POPOVER_MOTION_PROPS = {
	card: {
		initial: {
			scale: .97,
			willChange: "transform"
		},
		hidden: { opacity: 0 },
		visible: {
			opacity: 1,
			transition: {
				when: "beforeChildren",
				duration: POPOVER_MOTION_DURATION / 2
			}
		},
		scaleIn: { scale: 1 },
		scaleOut: { scale: .97 }
	},
	children: {
		hidden: { opacity: 0 },
		visible: { opacity: 1 }
	},
	transition: {
		type: "spring",
		visualDuration: POPOVER_MOTION_DURATION,
		bounce: .25
	}
};
/**
* @internal
*/
function _fillCSSObject(keys, value) {
	return keys.reduce((style, key) => (style[key] = value, style), {});
}
/**
* @public
*/
function rem(pixelValue) {
	return pixelValue === 0 ? 0 : `${pixelValue / 16}rem`;
}
/**
* @internal
*/
function _responsive(media, values, callback) {
	return (values?.map(callback) || []).map((statement, mediaIndex) => mediaIndex === 0 ? statement : { [`@media screen and (min-width: ${media[mediaIndex - 1]}px)`]: statement });
}
/**
* @internal
*/
function _getArrayProp(val, defaultVal) {
	return val === void 0 ? defaultVal || EMPTY_ARRAY : Array.isArray(val) ? val : [val];
}
/**
* @internal
*/
function _getResponsiveSpace(theme, props, spaceIndexes = EMPTY_ARRAY) {
	if (!Array.isArray(spaceIndexes)) throw Error("the property must be array of numbers");
	if (spaceIndexes.length === 0) return null;
	let { media, space } = getTheme_v2(theme);
	return _responsive(media, spaceIndexes, (spaceIndex) => _fillCSSObject(props, rem(space[spaceIndex])));
}
export { rem as a, POPOVER_MOTION_PROPS as c, _responsive as i, _getArrayProp as n, EMPTY_ARRAY as o, _getResponsiveSpace as r, EMPTY_RECORD as s, _fillCSSObject as t };

//# sourceMappingURL=helpers-bwfx1e-Y.js.map